const prefix = `/productTypes`

export default {
    getAll: () => axios.get(prefix),
}
